import type Polyglot from "node-polyglot"
import { createContext } from "react"
import { defaultPolyglot } from "./defaultPolyglot"

export type PolyglotContextValue = Polyglot

export const PolyglotContext = createContext<PolyglotContextValue>(defaultPolyglot)
